import { LanguageIcon, HandshakeIcon } from 'Components/common/Icons'

export const sideBarData = [
  {
    title: "Gerenciar",
    titleKey: "sidebar.manage",
    icon: "/img/icons/gear.svg",
    iconAlt: "Ícone de engrenagem",
    permissions: ["company_profile_r", "offices_r", "user_group_r", "users_r", "transparency_center_r", "transparency_config_w", "audit_logs_r"],
    children: [
      {
        title: "Perfil da empresa",
        titleKey: "sidebar.companyProfile",
        link: "/company-profile",
        permission: "company_profile_r",
      },
      {
        title: "Identidade Visual",
        titleKey: "sidebar.branding",
        link: "/settings/branding",
        permission: "company_profile_r",
      },
      { title: "Escritórios", titleKey: "sidebar.offices", link: "/offices", permission: "offices_r" },
      { title: "Programa de Privacidade e Proteção de Dados", titleKey: "sidebar.privacyProgram", link: "/compliance-program", permission: "assessment_gap_analysis_r" },
      {
        title: "Grupos de usuários",
        titleKey: "sidebar.userGroups",
        link: "/users-groups",
        permission: "user_group_r",
      },
      { title: "Usuários", titleKey: "sidebar.users", link: "/users", permission: "users_r" },
      { title: "Central de Transparência", titleKey: "sidebar.transparencyCenter", link: "/transparency-center/config", permission: "transparency_config_w" },
      {
        title: "Logs",
        titleKey: "sidebar.logs",
        link: "/audit-logs",
        permission: "audit_logs_r",
      },
    ],
    link: "#",
  },
  {
    title: "Mapeamento",
    titleKey: "sidebar.mapping",
    icon: "/img/icons/signature.svg",
    iconAlt: "Ícone de documento sendo assinado",
    permissions: [
      "general_map_r",
      "areas_r",
      "processes_r",
      "systems_r",
      "data_r",
      "assets_r"
    ],
    children: [
      { title: "Mapeamento geral", titleKey: "sidebar.generalMapping", link: "/map", permission: "general_map_r" },
      { title: "Áreas de negócio", titleKey: "sidebar.businessAreas", link: "/areas", permission: "areas_r" },
      { title: "Processos", titleKey: "sidebar.processes", link: "/processes", permission: "processes_r" },
      { title: "Sistemas", titleKey: "sidebar.systems", link: "/systems", permission: "systems_r" },
      { title: "Ativos", titleKey: "sidebar.assets", link: "/assets", permission: "assets_r" },
      { title: "Tipos de dados", titleKey: "sidebar.dataTypes", link: "/data", permission: "data_r" },
    ],
    link: "#",
  },
  {
    title: "Adequações",
    titleKey: "sidebar.compliance",
    icon: "/img/icons/file3.svg",
    iconAlt: "Ícone de documento",
    permissions: ["policies_r"],
    children: [
      { title: "Políticas", titleKey: "sidebar.policies", link: "/policies", permission: "policies_r" },
      {title: 'Gestão de Cookies e Consentimento', titleKey: "sidebar.cookiesManagement", link: '/cookies', permission: 'users_r'},
    ],
    link: "#",
  },
  {
    title: "Análises",
    titleKey: "sidebar.analysis",
    icon: "/img/icons/chart.svg",
    iconAlt: "Ícone de relatório",
    permissions: ["reports_ropa_r", "assessment_gap_analysis_r"],
    children: [
      {
        title: "Gap Analysis",
        titleKey: "sidebar.gapAnalysis",
        link: "/gap-analysis",
        permission: "assessment_gap_analysis_r",
      },
      {
        title: "Superficie de Ataques",
        titleKey: "sidebar.attackSurface",
        link: "/asm",
        permission: "reports_ropa_r",
      },
    ],
    link: "#",
  },
  {
    title: "Relatórios",
    titleKey: "sidebar.reports",
    icon: "/img/icons/report.svg",
    iconAlt: "Ícone de relatório",
    permissions: ["reports_ropa_r"],
    children: [
      {
        title: "Ropa",
        titleKey: "sidebar.ropa",
        link: "/reports/ropa",
        permission: "reports_ropa_r",
      },
      {
        title: "Programa de Privacidade e Proteção de Dados",
        titleKey: "sidebar.privacyProgram",
        link: "/reports/compliance-program",
        permission: "reports_gap_analysis_r",
      },
      {
        title: "Gap Analysis",
        titleKey: "sidebar.gapAnalysis",
        link: "/reports/gap-analysis",
        permission: "reports_gap_analysis_r",
      },
    ],
    link: "#",
  },
  {
    title: "Gestão de Riscos de Terceiros",
    titleKey: "sidebar.vendorRisk",
    icon: <HandshakeIcon />,
    iconAlt: "Ícone de aperto de mão",
    permissions: ["vendor_r", "assessment_r", "dashboard_r"],
    children: [
      {
        title: "Fornecedores",
        titleKey: "sidebar.vendors",
        link: "/vendors",
        permission: "vendor_r",
      },
      {
        title: "Avaliações",
        titleKey: "sidebar.assessments",
        link: "/vendor-assessments",
        permission: "assessment_r",
      },
      {
        title: "Dashboard",
        titleKey: "sidebar.vendorDashboard",
        link: "/vendor-dashboard",
        permission: "dashboard_r",
      },
    ],
    link: "#",
  },
];

export const sideBarDataSuperAdmin = [
  {
    title: "Configurações Globais",
    titleKey: "sidebar.globalSettings",
    icon: <LanguageIcon />,
    iconAlt: "Ícone do globo",
    permissions: ["company_r", "global_control_r", "global_standards_r", "audit_logs_r"],
    children: [
      { title: "Clientes", titleKey: "sidebar.clients", link: "/companies", permission: "company_r" },
      {
        title: "Logs",
        titleKey: "sidebar.logs",
        link: "/audit-logs/global",
        permission: "audit_logs_r",
      },
      {
        title: "Códigos de verificação dos usuários",
        titleKey: "sidebar.userVerifyCodes",
        link: "/users-verify-codes",
        permission: "audit_logs_r",
      },
      {
        title: "Dashboard de Operações",
        titleKey: "sidebar.opsDashboard",
        link: "/ops-dashboard",
        permission: "audit_logs_r",
      },
    ],
  },
];

export const sideBarDataPartners = [
  {
    title: "Parceiros",
    titleKey: "sidebar.partners",
    icon: <HandshakeIcon size={20} />,
    iconAlt: "Ícone do globo",
    permissions: ["partner_company_r"],
    children: [
      {
        title: "Clientes",
        titleKey: "sidebar.clients",
        link: "/companies-partner",
        permission: "partner_company_r",
      },
    ],
  },
];
